module.exports = __webpack_public_path__ + "img/baidu.990ea3a6.svg";